
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/immoscout24",
      function () {
        return require("private-next-pages/immoscout24.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/immoscout24"])
      });
    }
  